export interface Input {
  content: Marko.Body;
}

<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <link rel="icon" type="image/png" sizes="32x32" href="./favicon.png">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover">
    <meta name="description" content="Organize letters into words!">
    <link rel="manifest" href="/game/reduce/manifest.json">
    <meta name="apple-mobile-web-app-capable" content="yes">
    <meta name="apple-mobile-web-app-title" content="Reduce">
    <meta name="apple-mobile-web-app-status-bar-style" content="default">
    <meta name="theme-color" media="(prefers-color-scheme: light)" content="#F1DECD">
    <meta name="theme-color" media="(prefers-color-scheme: dark)" content="#271C13">
    <link rel="apple-touch-icon" href="/game/reduce/icon-192.png">
    <title>Reduce</title>
  </head>
  <body>
    <${input.content}/>
  </body>
</html>

<script>
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/game/reduce/sw.js");
</script>
